import { useLocation } from "@tanstack/react-router";
import { FileRouteTypes } from "../routeTree.gen";
import { ComponentType, useMemo } from "react";
import { Anchor } from "./Anchor";
import { useToastStore } from "&/toast";

interface NavAnchorProps {
  to: FileRouteTypes["to"];
  label: string;
  Icon: ComponentType<{ active?: boolean }>;
  hasNew?: boolean;
  disabled?: boolean;
}

export const NavAnchor = ({
  to,
  label,
  Icon,
  hasNew,
  disabled,
}: NavAnchorProps) => {
  const { add } = useToastStore();
  const { href } = useLocation();
  const active = useMemo(() => href.includes(to), [to, href]);

  return (
    <Anchor
      disabled={disabled}
      className="flex flex-1 flex-col items-center justify-center gap-0.5"
      onClick={
        disabled ? () => add("준비중입니다. 조금만 기다려주세요.") : undefined
      }
      to={to}
      replace
    >
      <span className="relative block w-6 h-6">
        <Icon active={active} />
        {hasNew && (
          <i className="absolute right-0 top-0 w-2 h-2 rounded-full bg-red border border-white" />
        )}
      </span>
      <span
        className={`text-[11px] font-medium ${active ? "text-yellow" : "text-gray"}`}
      >
        {label}
      </span>
    </Anchor>
  );
};
